import * as React from "react"
import { createRoot } from "react-dom/client"
import { Provider } from "react-redux"
import { Action } from "redux"

import OldUIContext from "../../olduicontext"
import { AppStore } from "../../store"

import * as actions from "./actions"
import ConceptsPage from "./components/ConceptsPage"
import { IOldUIContext } from "../../global"

interface OldUIInit {
    start: (element: HTMLElement | undefined | null) => void
    showCreateConceptModal: () => Action
}

function init(store: AppStore, oldUIContext: IOldUIContext): OldUIInit {
    const start = (element: HTMLElement | undefined | null): void => {
        if (!element) {
            throw new Error("Element should have value")
        }

        store.dispatch(actions.initialize())

        const root = createRoot(element)
        root.render(
            <Provider store={store}>
                <OldUIContext.Provider value={oldUIContext}>
                    <ConceptsPage />
                </OldUIContext.Provider>
            </Provider>,
        )
    }

    const showCreateConceptModal = (): Action =>
        store.dispatch(actions.updateCreateConceptVisibility(true))

    return {
        start,
        showCreateConceptModal,
    }
}

export default init
